import { useState } from 'react'
import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid';
import DataGridSkeleton from '../../shared/components/DataGridSkeleton';
import CustomPagination from '../../shared/utils/CustomPagination';
import { Box, Tooltip, Typography } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import useApartmentStore from '../../store/useApartmentStore';

const ApartmentListTable = ({ apartmentRows, isLoading }) => {

    console.log("apartmentRows", apartmentRows)

    const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 10 });

    const { setApartment } = useApartmentStore()
   
    const apartmentColumn = [
        {
            field: "sr_no",
            headerName: "Sr No",
              width:150,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>

        },
        {
            field: "apartment_name",
            headerName: "Apartment",
              width:150,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "no_of_flats",
            headerName: "No Of Flats",
              width:150,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "address",
            headerName: "Address",
              width:150,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "street",
            headerName: "Street",
              width:150,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "landmark",
            headerName: "Landmark",
              width:150,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "pincode",
            headerName: "Pincode",
              width:150,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "country_name",
            headerName: "Country",
              width:150,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "state_name",
            headerName: "State",
              width:150,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "city_name",
            headerName: "City",
        width:100,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "zone_name",
            headerName: "Zone",
              width:150,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "actions",
            type: "actions",
            headerName: "Actions",
              width:150,
            cellClassName: "actions",
            renderCell: (params) => (
                <Box sx={{ display: "flex", justifyContent: "center", width: "100%" }}>
                    <Tooltip title="Edit">
                        <GridActionsCellItem
                            key={0}
                            icon={<EditIcon />}
                            label="Edit"
                            onClick={() => {
                                if (params?.row) {
                                    setApartment(params.row);
                                    window.scrollTo({ top: 0, behavior: 'smooth' });
                                }
                            }}
                        />
                    </Tooltip>
                </Box>
            ),
        }

    ];
    return (
        <>

            {isLoading ? (
                <DataGridSkeleton rowsNum={10} />
            ) : (
                <DataGrid
                    rows={apartmentRows ?? []}
                    columns={apartmentColumn}
                    pagination
                    paginationModel={paginationModel}
                    onPaginationModelChange={setPaginationModel}
                    pageSizeOptions={[10]}
                    disableRowSelectionOnClick={true}
                    getRowId={(row) => row.apartment_id || row.id}
                    slots={{
                        pagination: () => (
                            <CustomPagination
                                paginationModel={paginationModel}
                                setPaginationModel={setPaginationModel}
                                totalRows={apartmentRows?.length || 0}
                                pageSize={paginationModel.pageSize}
                            />
                        ),
                    }}
                />
            )}
        </>
    )
}

export default ApartmentListTable